<template>
  <div class="info">
    <div class="top">
      <h2 class="name">租客管理</h2>
      <div class="content">
        <a-row>
          <a-col span="24">
            <a-form-model>
              <a-form-model-item label="日期">
                <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.startTime" />
                <a-date-picker style="margin-left:20px" valueFormat="YYYY-MM-DD" v-model="form.endTime" />
                <a-button style="margin-left: 10px" @click="handleClick">查询</a-button>
              </a-form-model-item>
            </a-form-model>
          </a-col>
        </a-row>
      </div>
    </div>

    <div style="background-color: #ffffff;">
      <a-row>
        <a-col span="24">
          <ECharts :chartData="chartData" />
        </a-col>
      </a-row>
    </div>
    <div style="background-color: #ffffff;">
      <a-row>
        <a-col span="24">
          <a-table
            rowKey="name"
            :columns="columns"
            :data-source="list"
          >
          </a-table>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getBeginMonth, getEndMonth } from '@/utils/date'
import ECharts from '@/views/achievement/statisticClientRent/ECharts.vue'
import { statisticClientRentQuery } from '@/api/system/achievement/list'

export default {
  name: 'ClientRent',
  components: {
    ECharts
  },
  data () {
    return {
      form: {
        startTime: this.$moment(getBeginMonth()).format('YYYY-MM-DD'),
        endTime: this.$moment(getEndMonth()).format('YYYY-MM-DD')
      },
      chartData: {
        xAxisData: [],
        seriesData: {}
      },
      list: [],
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          align: 'center'
        },
        // {
        //   title: '总客源数',
        //   dataIndex: 'clientCount'
        // },
        {
          title: '总跟进数',
          dataIndex: 'followUpCount'
        },
        {
          title: '总面访数',
          dataIndex: 'interviewCount'
        },
        {
          title: '总带看数',
          dataIndex: 'takeLookCount'
        }
      ]
    }
  },
  methods: {
    handleClick () {
      this.getDataList()
    },
    getDataList () {
      statisticClientRentQuery.call(this, this.form).then(res => {
        if (res.code === 200) {
          this.list = res.data.data
          this.chartData = {
            xAxisData: res.data.xaxisData,
            seriesData: res.data.seriesData
          }
        }
      })
    }
  },
  created () {
    this.getDataList()
  }
}
</script>

<style scoped lang="less">
.info {
  height: 100%;

  .top {
    height: 160px;
    padding-left: 20px;
    padding-top: 20px;
    background-color: white;

    .name {
      color: #000;
      font-weight: 700;
      font-size: 20px;
    }

    .content {
      /deep/ .ant-form {
        display: flex;
        align-items: center;
      }

      /deep/ .ant-form-item {
        display: flex;
        margin-bottom: 0px;
      }

      .week-month-season-year {
        font-weight: 700;
        color: #000;
        padding-left: 10px;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .bottom {
    margin-top: 10px;
    padding: 40px;
    background-color: white;

    .one-name {
      color: #000;
      font-size: 16px;
      font-weight: 700;
      margin-left: 200px;
      display: flex;
      justify-content: space-around;
    }

    .two-nameItem {
      color: #000;
      font-weight: 700;
      margin-left: 240px;
      display: flex;
      justify-content: space-around;
    }
  }

  #app {
    height: 500px;
  }
}
</style>
